module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("A Harvest Original •")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("HARCOURT, INC.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("Orlando")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("Austin")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("New York")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("San Diego")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("London")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Copyright © 2006 by Charles Yu")]), _c('p', {
    staticClass: "follow"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or"), _c('br'), _vm._v("\ntransmitted in any form or by any means, electronic or mechanical,"), _c('br'), _vm._v("\nincluding photocopy, recording, or any information storage and"), _c('br'), _vm._v("\nretrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Requests for permission to make copies of any part of the work"), _c('br'), _vm._v("\nshould be submitted online at "), _c('a', {
    attrs: {
      "href": "http://www.harcourt.com/contact",
      "target": "_blank"
    }
  }, [_vm._v("www.harcourt.com/contact")]), _vm._v(" or mailed"), _c('br'), _vm._v("\nto the following address: Permissions Department, Harcourt, Inc.,"), _c('br'), _vm._v("\n6277 Sea Harbor Drive, Orlando, Florida 32887-6777.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "http://www.HarcourtBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.HarcourtBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Earlier versions of the following stories appeared in the following"), _c('br'), _vm._v("\nmagazines: \"32.05864991%,\" "), _c('em', [_vm._v("The Malahat Review;")]), _vm._v(" 'Autobiographical Raw"), _c('br'), _vm._v("\nMaterial Unsuitable for the Mining of Fiction,\" "), _c('em', [_vm._v("Alaska Quarterly Review;")]), _c('br'), _vm._v("\n\"Third Class Superhero\" appeared as \"Class Three Superhero,\""), _c('br'), _vm._v(" "), _c('em', [_vm._v("Mid-American Review;")]), _vm._v(" \"Florence,\" "), _c('em', [_vm._v("Eclectica;")]), _vm._v(" \"My Last Days As Me,\""), _c('br'), _vm._v(" "), _c('em', [_vm._v("Sou'wester,")]), _vm._v(" reprinted in the "), _c('em', [_vm._v("Robert Olen Butler Prize Stories 2004;")]), _vm._v(" \"Problems"), _c('br'), _vm._v("\nfor Self-Study,\" "), _c('em', [_vm._v("Harvard Review;")]), _vm._v(" \"Realism,\" "), _c('em', [_vm._v("Mississippi Review;")]), _vm._v(" \"The Man Who"), _c('br'), _vm._v("\nBecame Himself,\" "), _c('em', [_vm._v("The Gettysburg Review;")]), _vm._v(" \"Two-Player Infinitely Iterated"), _c('br'), _vm._v("\nSimultaneous Semi-Cooperative Game with Spite and Reputation,\" "), _c('em', [_vm._v("Eclectica.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("\nYu, Charles, 1976–"), _c('br'), _vm._v("\nThird class superhero/Charles Yu.—1st ed."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\n\"A Harvest original.\""), _c('br'), _vm._v("\nI. Title."), _c('br'), _vm._v("\nPS3625.U15T48 2006"), _c('br'), _vm._v("\n813'.6—dc22 2006004786"), _c('br'), _vm._v("\nISBN-13: 978-0-15-603081-6 ISBN-10: 0-15-603081-0")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Text set in Mrs. Eaves Roman"), _c('br'), _vm._v("\nDesigned by Scott Piehl")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("First edition")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A B C D E F G H I J K")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_vm._v("for my parents")]), _c('p', {
    staticClass: "follow"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', {
    staticClass: "fronttitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 1")]), _vm._v(" 1 Third Class Superhero")]), _c('p', {
    staticClass: "follow"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 2")]), _vm._v(" 25 401(k)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 3")]), _vm._v(" 37 The Man Who Became Himself")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 4")]), _vm._v(" 55 Problems for Self-Study")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 5")]), _vm._v(" 67 My Last Days As Me")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 6")]), _vm._v(" 89 Two-Player Infinitely Iterated Simultaneous Semi-Cooperative Game with Spite and Reputation")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 7")]), _vm._v(" 99 Realism")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 8")]), _vm._v(" 111 Florence")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 9")]), _vm._v(" 131 Man of Quiet Desperation Goes on Short Vacation")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 10")]), _vm._v(" 143 32.05864991%")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Story 11")]), _vm._v(" l6l Autobiographical Raw Material Unsuitable for the Mining of Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Acknowledgments")]), _vm._v(" 175")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc8bbfb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front.vue
// module id = 57
// module chunks = 0